import { PAGE_TRANSITION_TIME_MS } from "../constants";

export const applyFadeOutRedirect = (
  container,
  navigate,
  newPathLink = "/",
  onSmallDevice = false
) => {
  if (!container) {
    return navigate(newPathLink.toLowerCase());
  }
  container.classList.add("page-fade-out");

  /**
   * desktop: need this class so image container doesn't jump
   * on small devices: project images have different layout so does not apply
   **/
  if (!onSmallDevice) {
    container.classList.add("full-screen");
  }

  setTimeout(() => {
    navigate(newPathLink.toLowerCase());
  }, PAGE_TRANSITION_TIME_MS);
};
